import React from 'react';
import { SubscriptionForm } from './SubscriptionForm';
import { StoryCard } from './StoryCard';
import { TrendingUp, DollarSign } from 'lucide-react';
export function Sidebar() {
  return <aside className="space-y-8 sticky top-24" data-id="element-59">
      <SubscriptionForm data-id="element-60" />

      <div className="bg-white border border-gray-200 p-6" data-id="element-61">
        <div className="flex items-center mb-4 border-b border-gray-200 pb-2" data-id="element-62">
          <TrendingUp className="w-4 h-4 mr-2 text-accent" data-id="element-63" />
          <h3 className="font-bold uppercase tracking-wider text-sm" data-id="element-64">
            Trending Now
          </h3>
        </div>
        <div className="space-y-0" data-id="element-65">
          <StoryCard title="The Future of Urban Architecture in South Asia" excerpt="" author="Sarah Jenkins" category="Lifestyle" timestamp="2h ago" compact={true} data-id="element-66" />
          <StoryCard title="Tech Giants Face New Regulations in EU" excerpt="" author="Mark Davis" category="Technology" timestamp="4h ago" compact={true} data-id="element-67" />
          <StoryCard title="Review: The New Symphony Hall Opens Doors" excerpt="" author="Elena Rostova" category="Arts" timestamp="5h ago" compact={true} data-id="element-68" />
        </div>
      </div>

      <div className="bg-ink text-paper p-6" data-id="element-69">
        <div className="flex items-center mb-4 border-b border-gray-700 pb-2" data-id="element-70">
          <DollarSign className="w-4 h-4 mr-2 text-paper" data-id="element-71" />
          <h3 className="font-bold uppercase tracking-wider text-sm" data-id="element-72">
            Market Snapshot
          </h3>
        </div>
        <div className="space-y-3 font-mono text-sm" data-id="element-73">
          <div className="flex justify-between items-center" data-id="element-74">
            <span className="text-gray-400" data-id="element-75">S&P 500</span>
            <span className="text-green-400" data-id="element-76">+1.24%</span>
          </div>
          <div className="flex justify-between items-center" data-id="element-77">
            <span className="text-gray-400" data-id="element-78">NASDAQ</span>
            <span className="text-green-400" data-id="element-79">+0.85%</span>
          </div>
          <div className="flex justify-between items-center" data-id="element-80">
            <span className="text-gray-400" data-id="element-81">FTSE 100</span>
            <span className="text-red-400" data-id="element-82">-0.32%</span>
          </div>
          <div className="flex justify-between items-center" data-id="element-83">
            <span className="text-gray-400" data-id="element-84">NIKKEI</span>
            <span className="text-green-400" data-id="element-85">+2.10%</span>
          </div>
          <div className="mt-4 pt-3 border-t border-gray-700 text-xs text-gray-500 font-sans text-center" data-id="element-86">
            Data delayed by 15 mins
          </div>
        </div>
      </div>
    </aside>;
}